import { render, staticRenderFns } from "./Itens.vue?vue&type=template&id=9fa70aee&scoped=true&"
import script from "./Itens.vue?vue&type=script&lang=js&"
export * from "./Itens.vue?vue&type=script&lang=js&"
import style0 from "./Itens.vue?vue&type=style&index=0&id=9fa70aee&lang=scss&scoped=true&"
import style1 from "./Itens.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa70aee",
  null
  
)

export default component.exports